import { useState, useEffect } from 'react';
import { msalInstance } from '../authConfig';
import { api } from '../utils/api';

export const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const initAuth = async () => {
      await msalInstance.initialize();
      
      const response = await msalInstance.handleRedirectPromise();
      if (response && response.account) {
        const backendResponse = await api.authenticate({
          idToken: response.idToken,
          email: response.account.username,
          name: response.account.name
        });
        
        localStorage.setItem('authToken', backendResponse.token);
        localStorage.setItem('userEmail', backendResponse.email);
        localStorage.setItem('userName', backendResponse.name);
        
        setIsAuthenticated(true);
        setUser({ email: backendResponse.email, name: backendResponse.name });
        return;
      }
      
      const token = localStorage.getItem('authToken');
      const email = localStorage.getItem('userEmail');
      const name = localStorage.getItem('userName');
      
      if (token && email) {
        setIsAuthenticated(true);
        setUser({ email, name });
      }
    };
    
    initAuth();
  }, []);

  const handleLoginSuccess = (data) => {
    setIsAuthenticated(true);
    setUser({ email: data.email, name: data.name });
  };

  const handleLogout = async () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('userEmail');
    localStorage.removeItem('userName');
    await msalInstance.logoutPopup();
    setIsAuthenticated(false);
    setUser(null);
  };

  const getUserId = () => {
    return user?.email || localStorage.getItem('userEmail') || 'anonymous';
  };

  const isAdmin = user?.email === 'nicola.contin@wecanconsulting.it' || user?.email === 'francesco.terranova@bellascelta.it';

  return {
    isAuthenticated,
    user,
    isAdmin,
    getUserId,
    handleLoginSuccess,
    handleLogout
  };
};
